import { render, staticRenderFns } from "./afiliados.vue?vue&type=template&id=59626587"
import script from "./afiliados.vue?vue&type=script&lang=js"
export * from "./afiliados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports